import { render, staticRenderFns } from "./ReminderMails.vue?vue&type=template&id=6c3d7662"
import script from "./ReminderMails.vue?vue&type=script&lang=js"
export * from "./ReminderMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports